/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
// Ember imports
import { isEmpty } from '@ember/utils';
// External imports
import PostStatus from '@linc-technologies/linced-common/enums/post-status';
import moment from 'moment';

export default class BulkPublishRoute extends Route {
  queryParams = {
    groupId: {
      refreshModel: true,
    },
    proofreadPosts: {
      refreshModel: true,
    },
    notProofread: {
      refreshModel: true,
    },
    pageIds: {
      refreshModel: true,
    },
    authorIds: {
      refreshModel: true,
    },
    startDate: {
      refreshModel: true,
    },
    endDate: {
      refreshModel: true,
    },
    draftPosts: {
      refreshModel: true,
    },
    publishedPosts: {
      refreshModel: true,
    },
    staffOnly: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let groupId;
    if (!isEmpty(params.groupId)) {
      groupId = params.groupId;
    }
    let pageIds;
    if (!isEmpty(params.pageIds)) {
      pageIds = params.pageIds;
    }
    let authorIds;
    if (!isEmpty(params.authorIds)) {
      authorIds = params.authorIds;
    }
    let isProofread;
    if (!isEmpty(params.proofreadPosts)) {
      isProofread = params.proofreadPosts;
    }
    let isNotProofread;
    if (!isEmpty(params.notProofread)) {
      isNotProofread = params.notProofread;
    }
    let startTime = 0;
    if (!isEmpty(params.startDate)) {
      startTime = moment(params.startDate).startOf('day').unix();
    }
    let endTime = 0;
    if (!isEmpty(params.endDate)) {
      endTime = moment(params.endDate).endOf('day').unix();
    }

    let postParams = {
      groupId,
      pageIds,
      authorIds,
      isProofread,
      isNotProofread,
      visibleToParentsOrLearners: true,
      statuses: JSON.stringify([PostStatus.DRAFT, PostStatus.UNPUBLISHED]),
      include: 'reactions,comments',
      startTime,
      endTime,
    };

    return this.store.query('posts/post', postParams);
  }
}
